module.exports = __webpack_public_path__ + "static/pic-2@2x-3996f181c83d0cdf81131bc96ee5dbfe.png";